import React from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/icons/logo.svg?react";

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation(); // Get current path

  const getLinkClass = (path: string) =>
    location.pathname === path
      ? "text-red-600 "
      : "text-gray-700 hover:text-gray-900";

  return (
    <nav className="bg-white shadow-sm w-full">
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link
              to="/"
              className="text-xl font-bold text-gray-900"
              aria-label="Pagina principală GabyLen Auto"
            >
              <Logo className="h-40 w-auto" />
            </Link>
          </div>
          <div className="hidden sm:flex sm:items-center">
            <div className="space-x-8">
              <Link
                to="/itp"
                className={getLinkClass("/itp")}
                aria-label="Rezervă inspecția tehnică periodică ITP"
              >
                ITP
              </Link>
              <Link
                to="/portofoliu"
                className={getLinkClass("/portofoliu")}
                aria-label="Lucrarile cu care ne mandrim"
              >
                Portofoliu
              </Link>
              <Link
                to="/servicii"
                className={getLinkClass("/servicii")}
                aria-label="Vezi serviciile disponibile"
              >
                Servicii
              </Link>
              <Link
                to="/contact"
                className={getLinkClass("/contact")}
                aria-label="Contactati-ne pentru mai multe detalii"
              >
                Contact
              </Link>
            </div>
          </div>
          <div className="flex items-center sm:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-gray-900"
              aria-label={isOpen ? "Închide meniul" : "Deschide meniul"}
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        {isOpen && (
          <div className="sm:hidden pb-4" role="menu">
            <div className="flex flex-col space-y-4">
              <Link
                to="/itp"
                className={getLinkClass("/itp")}
                aria-label="Rezervă inspecția tehnică periodică ITP"
                role="menuitem"
                onClick={() => setIsOpen(false)}
              >
                ITP
              </Link>
              <Link
                to="/portofoliu"
                className={getLinkClass("/portofoliu")}
                aria-label="Lucrarile cu care ne mandrim"
                role="menuitem"
                onClick={() => setIsOpen(false)}
              >
                Portofoliu
              </Link>
              <Link
                to="/servicii"
                aria-label="Vezi serviciile disponibile"
                role="menuitem"
                className={getLinkClass("/servicii")}
                onClick={() => setIsOpen(false)}
              >
                Servicii
              </Link>
              <Link
                to="/contact"
                className={getLinkClass("/contact")}
                onClick={() => setIsOpen(false)}
                aria-label="Contactati-ne pentru mai multe detalii"
                role="menuitem"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
export default Navbar;
